
















import Vue from 'vue'
import { getArticle } from '@/apps/lianwen/api/story/article'

import { Component } from 'vue-property-decorator'
import Article from '../../model/article'
@Component({
  components: {}
})
export default class ArticleDetail extends Vue {
  private article: Article = {}
  async mounted() {
    const articleId = this.$route.params.articleid

    this.article = await getArticle(articleId)
  }
}
